import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { PaymentMethodsEnum } from "src/app/models/enums/payment-methods.enum";
import { PaymentPreferenceEnum } from "src/app/models/enums/payment-preference.enum";
import { PaymentDetails } from "src/app/models/payment-details.model";
import { CustomerService } from "src/app/services/customer.service";

@Component({
    selector: 'payment-method-dashboard-component',
    templateUrl: './payment-method-dashboard.component.html',
    styleUrls: ['./payment-method-dashboard.component.scss'],
    standalone: true,
    imports: [ButtonModule, CardModule],
    providers: [CustomerService]
})
export class PaymentMethodDashboardComponent {
    paymentDetails!: PaymentDetails;

    PaymentMethod = PaymentMethodsEnum;

    @Input() activeTab!: string;
    @Output() activeTabChange = new EventEmitter<string>();

    constructor(private customerService: CustomerService) {
        this.customerService.getInvoicingInfo().subscribe((data) => {
            this.paymentDetails = data;
        });
    }
}